var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
// eslint-disable
/** config: begin */
export * from '../config/config.js';
/** config: end */
/** monkeySys: begin */
export * from '../monkeySys.js';
/** monkeySys: end */
/** scope: begin */
import { BeanScopeBase } from 'zova';
import { Scope } from 'zova-module-a-bean';
export let ScopeModuleASsrhmr = (_dec = Scope(), _dec2 = __z_BeanInfo({
  module: "a-ssrhmr"
}), _dec(_class = _dec2(_class = class ScopeModuleASsrhmr extends BeanScopeBase {}) || _class) || _class);
import 'zova';

/** scope: end */